<template>
  <div id="photo">
    <van-nav-bar :title="lang.up_title" left-arrow :right-text="lang.chucun" @click-right="savePic('warp')" @click-left="prev" />
    <section>
      <!-- 未上传展示 -->
      <div class="up—warp">
        <van-uploader multiple :after-read="onRead" :max-size="20971520">
          <div class="upItem">
            <svg class="icon camera" aria-hidden="true">
              <use xlink:href=" #icon-xiangji_x" />
            </svg>
            <span>{{ lang.up_title }} </span>
          </div>
        </van-uploader>
      </div>
      <!-- draggable: '.up-img'  :delay="1.8"-->
      <draggable
        group="itxst"
        :list="preview"
        :options="{ disabled: preview.length == 0 ? true : false }"
        class="dargger"
        handle=".handle"
        :disabled="isUpLoading"
        @start="start"
        @end="dragEnd"
        animation="100"
      >
        <!-- 上传展示  使用tap指令 兼容三星浏览器拖拽点击事件冲突-->
        <div v-for="(item, index) in preview" :key="index" class="up-img" v-tap="[showImage, index, 'tap']" @click="showImage(index, 'click')" :class="{ handle: preview[index] ? true : false }">
          <img :src="item.localPath || item.imagePath + '?x-oss-process=style/' + '150xauto_f'" @touchstart="onTouchForceChange" />
          <span v-if="item.localPath && !item.imagePath" class="up-loading">{{ curQueue.file.localPath == item.localPath ? lang.imgloading : lang.Inline }}</span>
          <span v-else-if="!item.localPath && !item.imagePath" class="up-loading"> {{ lang.imgfaile }} <br />{{ lang.imgdel }} </span>
          <span class="first" v-if="index == 0">{{ lang.first }}</span>
          <div class="showText" v-show="item.imageTypeWithCulture || item.imageDesc">
            <span class="firstLine">{{ item.imageTypeWithCulture }}</span>
            <span>{{ item.imageDesc }}</span>
          </div>
        </div>
      </draggable>
      <!-- 预览图 -->
      <div class="prev-com" v-show="show" v-if="preview[nowIndex]">
        <van-image-preview v-model="show" :async-close="show" :images="images" @change="onChange" :start-position="nowIndex"> </van-image-preview>
        <div class="indicator">
          <div class="back" @click="exit">
            <svg class="icon">
              <use xlink:href="#icon-jiantou_bai" />
            </svg>
          </div>
          <div class="idx">{{ nowIndex + 1 }}/{{ images.length }}</div>
          <div @click="savePic">{{ lang.chucun }}</div>
        </div>
        <!-- 图片描述 -->
        <div class="cus-input">
          <div class="type" @click="showImgLocation = true">
            <span>{{ preview[nowIndex].imageTypeWithCulture || lang.photoPosition }}</span>
            <van-icon name="arrow-down" />
          </div>
          <textarea class="desc" maxlength="50" type="text" v-model="preview[nowIndex].imageDesc" :placeholder="lang.photoMax"></textarea>
        </div>
        <!-- 图片位置 -->
        <div class="picLocation">
          <van-popup v-model="showImgLocation">
            <div class="loca-content">
              <div class="head">
                <h3>{{ lang.photoPosition }}</h3>
                <span @click="quitChoose(nowIndex)">{{ lang.quitChoose }}</span>
              </div>
              <div class="content" v-if="preview[nowIndex]">
                <van-radio-group v-model="preview[nowIndex].imageType" v-for="item in imgTypeBase" :key="item.sequence">
                  <van-cell :title="item.dictionaryNameWithCulture" clickable @click="selectType(item)">
                    <template #right-icon>
                      <van-radio :name="item.dictionaryValue" checked-color="#ED1818" />
                    </template>
                  </van-cell>
                </van-radio-group>
              </div>
            </div>
          </van-popup>
        </div>
      </div>
      <!-- 推拽到此处删除 -->
      <draggable group="itxst" :list="delImg" @add="dragEnd">
        <div class="del" v-show="startDrag">{{ lang.moveDel }}</div>
      </draggable>
      <div class="tip">
        {{ lang.maximumPhotos1 }}<i class="white">{{ preview.length || 0 }}</i
        >{{ lang.maximumPhotos2 }}<br />{{ lang.photoIntro }} <br />{{ lang.photoIntro2 }}
      </div>
      <!-- 对话框 -- 未保存提示 -->
      <van-dialog v-model="exitTip" :title="lang.notSave" @confirm="clearChange" show-cancel-button class="exit" :confirm-button-text="lang.confirm" :cancel-button-text="lang.cancel">
        <p>{{ lang.saveTip }}</p>
      </van-dialog>
    </section>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant';
import draggable from 'vuedraggable';
import lang from './../../../common/language/post';
import pub from './../../../common/public.js';
const conf = require('./../../../common/js/_conf'); //判断环境

export default {
  data() {
    return {
      delImg: [],
      startDrag: false,
      lang: lang,
      nowIndex: 0,
      radio: '',
      file: [], // 存放file对象的数组 用来展示loading
      preview: [], // 接口返回的预览图
      curData: [], // 刚进入页面的时候的数据,离开时对比.如果发生了改变询问是否要保存
      images: [], //预览图
      show: false,
      exitTip: false,
      showImgLocation: false, //图片选择展示
      imgTypeBase: [], //图片类型数据字典
      imgQueue: {}, //图片字典
      curQueue: {}, //正在上传中的字典
      isUpLoading: false, //当前是否有图片在上传中
    };
  },
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    draggable,
  },
  created() {
    // 引入图片上传插件
    let zipImg = document.createElement('script');
    zipImg.type = 'text/javascript';
    zipImg.src = '//static.centanet.com/public/js/oss-upload.js';
    document.body.appendChild(zipImg);
    zipImg.onload = () => this.initZipImg();
    this.pub.getDictionary().then((res) => {
      this.imgTypeBase = [...res.PropertyImageType.children];
    });

    this.preview = JSON.parse(JSON.stringify(this.store.state.images));
    this.curData = JSON.parse(JSON.stringify(this.store.state.images));
  },
  watch: {
    preview(newValue, oldValue) {
      if (newValue.length > 20) {
        this.preview = this.preview.slice(0, 20);
        Toast(this.lang.picLength);
      }
    },
  },
  methods: {
    onTouchForceChange(e) {
      e.preventDefault();
    },
    quitChoose(i) {
      this.showImgLocation = false;
      this.preview[i].imageTypeWithCulture = '';
      this.preview[i].imageType = '';
    },
    clearChange() {
      this.show = false;
      this.preview = JSON.parse(JSON.stringify(this.curData));
    },
    /*结束拖拽*/
    dragEnd() {
      this.startDrag = false;
    },
    /*开始拖拽*/
    start() {
      this.startDrag = true;
    },
    selectType(item) {
      this.preview[this.nowIndex].imageType = item.dictionaryValue;
      this.preview[this.nowIndex].imageTypeWithCulture = item.dictionaryNameWithCulture;
      this.showImgLocation = false;
    },
    savePic(type) {
      if (type == 'warp') {
        let temp = [];
        // 返回的时候如果有正在上传的图片 , 暂时不存入vuex
        temp = this.preview.filter((item) => {
          // 如果有localPath属性 说明没有上传成功  || imagePath为null说明上传失败
          return !item.hasOwnProperty('localPath') && item.imagePath != null;
        });
        // console.log("temp",temp)
        this.store.commit('setImages', temp);
        // console.log("previews",this.preview)
        // console.log("imageshhh",this.store.state.images)
        window.stop();
        // location.href = "javascript:history.go(-1);"
        // history.back(-1)
        this.$router.go(-1);
      } else {
        this.show = false;
        this.curData = JSON.parse(JSON.stringify(this.preview));
      }
    },
    prev() {
      window.stop();
      this.$router.go(-1);
    },
    exit() {
      if (JSON.stringify(this.preview) === JSON.stringify(this.curData)) {
        this.show = false;
      } else {
        this.exitTip = true;
      }
    },
    showImage(index, from) {
      if (this.preview[index].imagePath === null) {
        Toast(this.lang.picuping);
        return;
      }
      this.images = [];
      this.preview.forEach((item) => {
        this.images.push(item.imagePath + '?x-oss-process=style/720x540_c' + pub.checkWebp());
      });
      this.nowIndex = index;
      this.show = true;
    },
    onChange(index) {
      this.nowIndex = index;
    },
    initZipImg() {
      var bucket = 'house730-uat-files';
      if (conf.env_type == 3 || conf.env_type == 4) {
        bucket = 'house730-files';
      } else {
        bucket = 'house730-uat-files';
      }
      this.$upload = new $upload({
        // 可选参数
        maxWidth: 1920, //最大压缩宽度(仅针对图片文件生效)
        maxHeight: 1920, //可选参数,最大压缩高度(仅针对图片文件生效)
        zipLimit: 3000, //压缩上传阈值，单位KB， 超过此大小则压缩，否则原图上传(仅针件图片文件生效)
        // 必选参数 OSS配置
        region: 'oss-accelerate',
        accessKeyId: 'LTAI4FndXDCKXK4tEMRgRBBv',
        accessKeySecret: 'TKLkHAOMxiDNf1PjoGX7KguYmeqJgx',
        bucket,
        // bucket: 'house730-files'
      });
    },
    // 图片上传预处理
    onRead(value) {
      if (value.constructor === Object) {
        value = [{ ...value }];
      }

      value.forEach((item, index) => {
        if (!item.file.name.toLocaleLowerCase().match(/(.*)\.(jpg|jpeg|png)$/)) {
          Toast(this.lang.fileError);
          return;
        }
        value[index] = item.file;
        // 时间戳+id生成唯一标识符
        value[index].id = new Date().getTime() + index;
        // 生成本地临时图片
        const windowURL = window.URL || window.url || window.webkitURL;
        const dataimgurl = windowURL.createObjectURL(item.file);
        value[index].localPath = dataimgurl;
        this.imgQueue[item.file.id] = item;
        // console.log("dataimgurl",dataimgurl)
        // console.log("imgquene",this.imgQueue)
        this.preview.push({
          localPath: dataimgurl,
          imagePath: null,
          imageType: '',
          imageDesc: '',
        });
      });
      if (!this.isUpLoading) {
        this.goUp();
      }
    },
    // 上传图片
    async goUp() {
      let _this = this;
      if (Object.keys(this.imgQueue).length > 0) {
        try {
          this.curQueue.id = Object.keys(this.imgQueue)[0];
          this.curQueue.file = this.imgQueue[this.curQueue.id].file;
          _this.isUpLoading = true;
          const result = await _this.$upload.go(_this.curQueue.file);
          //上传成后删除列队中的文件
          delete _this.imgQueue[_this.curQueue.id];
          if (conf.env_type == 3 || conf.env_type == 4) {
            result.url = result.url.replace('house730-files.oss-accelerate.aliyuncs.com', 'img.house730.com').replace('http://', 'https://');
            console.log("111",result.url)
          }else if(conf.env_type == 2 && process.env.VUE_APP_TYPE == 'uat'){
            result.url = result.url.replace('house730-uat-files.oss-accelerate.aliyuncs.com', 'uatimg.house730.com.cn').replace('https://', 'http://');;
            console.log(process.env.VUE_APP_TYPE,"333",result.url)
          } else {
            result.url = result.url.replace('house730-uat-files.oss-accelerate.aliyuncs.com', 'uatimg.house730.com.cn');
            console.log("222",result.url)
          }
          // let url = result.url.replace('house730-files.oss-accelerate.aliyuncs.com', 'img.house730.com').replace('http://', 'https://');
          // 上传成功后删除临时图片localPath 让img使用imagePath属性
          _this.preview.forEach((e, i) => {
            if (e.localPath === _this.curQueue.file.localPath) {
              delete _this.preview[i].localPath;
              _this.preview[i].imagePath = result.url;
            }
          });
          this.curData = JSON.parse(JSON.stringify(this.preview));
          _this.goUp();
        } catch (err) {
          let count = _this.curQueue.file.count || 0;
          count += 1;
          _this.curQueue.file.count = count;
          //错误次数小于5次, 继续重试
          if (count <= 5) {
            _this.goUp();
          } else {
            delete _this.imgQueue[_this.curQueue.id];
            //多次上传失败,删除错误图片,继续上传剩余图片
            _this.preview.forEach((e, i) => {
              if (e.localPath === _this.curQueue.file.localPath) delete _this.preview[i].localPath;
            });
            _this.goUp();
          }
        }
      } else {
        this.isUpLoading = false;
        this.curQueue = {};
        this.curData = JSON.parse(JSON.stringify(this.preview));
      }
    },
  },
  metaInfo() {
    return {
      title: this.lang.up_title,
    };
  },
};
</script>

<style lang="scss" scoped>
/deep/ .van-image-preview__image {
  width: 100%;
  height: auto;
}
.exit {
  z-index: 99999 !important;
  p {
    padding: 20px 30px;
    text-align: center;
    font-size: 17px;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
  }
}

.dargger {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 80px;
}
.van-nav-bar {
  .van-nav-bar__text {
    color: #ed1818;
    font-weight: bold;
  }
}

#photo {
  width: 100%;
  height: 100%;
  text-align: left;
}
section {
  background: #090a0a;
  padding: 20px 15px;
  position: relative;
  min-height: 100%;
}
/deep/.van-overlay {
  background-color: rgba(0, 0, 0, 0.9);
}

.del {
  height: 90px;
  width: 100%;
  background: #ed1818;
  font-size: 17px;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  line-height: 88px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9;
}
.tip {
  width: 95%;
  background: rgba(0, 0, 0, 0.75);
  border: 1px solid #999999;
  border-radius: 4px;
  color: #999999;
  position: fixed;
  left: 10px;
  bottom: 15px;
  line-height: 24px;
  text-align: center;
  .white {
    color: #fff;
    display: inline-block;
    margin: 0 2px;
  }
}
.up—warp {
  display: none;
  width: 105px;
  height: 105px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid #666666;
  border-radius: 2px;
  position: absolute;
  display: inline-block;
  margin-right: 5px;
  margin-left: 5px;
  margin-top: 10px;
  .van-uploader {
    width: 100%;
    height: 100%;
  }
  .upItem {
    position: absolute;
    top: 50%;
    left: 50%;
    text-align: center;
    transform: translate(-50%, -50%);
    width: 100%;
    .camera {
      font-size: 37px;
      display: inline-block;
      text-align: center;
    }
    span {
      display: block;
      font-size: 12px;
      font-weight: 400;
      text-align: center;
      color: #999999;
      line-height: 30px;
      margin-left: -5px;
    }
  }
}
.up-img {
  width: 105px;
  height: 105px;
  display: inline-block;
  position: relative;
  margin-right: 5px;
  margin-left: 5px;
  margin-top: 10px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 2px;
  }
  .showText {
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 30px;
    padding: 0 5px;
    background: rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
    span.firstLine {
      // margin-bottom: 2px;
    }
    span {
      height: 14px;
      display: block;
      width: 100%;
      font-size: 11px;
      font-weight: 400;
      text-align: left;
      color: #ffffff;
      line-height: 16px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .first {
    position: absolute;
    width: 34px;
    height: 16px;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
    line-height: 17px;
    top: 0;
    left: 0;
    opacity: 0.5;
    background: #000000;
  }
}
.up-img:first-child {
  margin-left: 120px;
}
.van-image-preview {
  /deep/.van-image-preview__index {
    display: none;
  }
}
.indicator {
  box-sizing: border-box;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  height: 44px;
  font-size: 17px;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
  z-index: 99999;
  line-height: 44px;
  .back {
    font-size: 25px;
    color: #ffffff;
  }
  .idx {
    margin-left: 20px;
    color: #ffffff;
  }
}
.cus-input {
  padding: 0 20px;
  position: fixed;
  bottom: 20px;
  width: 80%;
  left: 20px;
  font-size: 16px;
  box-sizing: border-box;
  z-index: 9999;
  input::-webkit-input-placeholder {
    color: #fff;
  }
  .type {
    color: #ffffff !important;
    height: 40px;
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid #999999;
    width: 100%;
    border-radius: 4px;
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    line-height: 40px;
    padding: 0 15px;
    i {
      line-height: 40px;
    }
  }
  .desc {
    padding: 8px 15px;
    width: 100%;
    height: 54px;
    background: rgba(0, 0, 0, 0.35);
    border: 1px solid #999999;
    border-radius: 4px;
    color: #fff;
  }
}
.picLocation {
  /deep/.van-popup {
    z-index: 9999 !important;
    width: 90%;
    height: 80%;
    border-radius: 5px;
  }
  .loca-content {
    height: 200px;
    background: #fff;
    .head {
      padding: 18px 18px 10px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #eee;
      h3 {
        font-size: 17px;
        font-weight: 600;
        text-align: left;
        color: #333333;
        line-height: 24px;
      }
      span {
        font-size: 12px;
        font-weight: 400;
        text-align: right;
        color: #0076ff;
        line-height: 17px;
      }
    }
  }
}
@media screen and (min-width: 414px) {
  section {
    padding: 20px 25px;
  }
  .up-img {
    margin-top: 15px;
    margin-right: 8px;
    margin-left: 8px;
  }
  .up—warp {
    margin-top: 15px;
    margin-right: 8px;
    margin-left: 8px;
  }
  .up-img:first-child {
    margin-left: 130px;
  }
}
@media only screen and (max-width: 320px) {
  section {
    padding: 20px 10px;
  }
  .up-img {
    width: 90px;
    height: 90px;
  }
  .up—warp {
    width: 90px;
    height: 90px;
  }
  .up-img:first-child {
    margin-left: 105px;
  }
}
.up-loading {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 105px;
  height: 105px;
  text-align: center;
  padding-top: 45px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.4);
}
</style>
